// src/App.tsx
import React from 'react';
import './App.css';
import HexagonalCircleGenerator from './components/hexagonal-circle-generator';

const App: React.FC = () => {
  return (
    <div className="App">
      <HexagonalCircleGenerator /> {}
    </div>
  );
};

export default App;
